<template>
	<div>
		<el-form inline="">
			<el-form-item label="填写的手机号">
				<el-input v-model="query.phone" size="small" @keydown.enter.native="getList()" clearable=""
					style="width: 150px;"></el-input>
			</el-form-item>
			<!-- <el-form-item label="用户id">
				<el-input v-model="query.userId" size="small" @keydown.enter.native="getList()" clearable="" style="width: 120px;"></el-input>
			</el-form-item> -->
			<el-select v-model="query.type" style="width: 150px;margin-right: 20px;" size="small">
				<el-option v-for="item in keyss" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
			<el-input type="text" style="width: 250px;margin-right: 20px;" size="small" v-model="query.text"></el-input>
			<el-form-item label="添加时间">
				<el-date-picker type="daterange" v-model="query.time" @change="getList()" size="small"
					value-format="yyyy-MM-dd" style="width: 250px;">
				</el-date-picker>
			</el-form-item>
			<el-form-item label="状态">
				<el-select v-model="query.status" @change="getList()" clearable="" size="small" style="width: 100px;">
					<el-option label="未充值" value="0"></el-option>
					<el-option label="已充值" value="1"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-button @click="getList()" size="small" type="primary">查询</el-button>
			</el-form-item>
			<el-form-item>
				<el-button @click="changeMult()" size="small" type="info">一键充值</el-button>
			</el-form-item>
			<el-form-item>
				<el-button @click="toggleRowSelection()" size="small">取消多选</el-button>
			</el-form-item>
		</el-form>
		<div class="flex" style="float: right;margin-top: -60px;margin-bottom: 10px;">
			<div>
				<el-button type="primary" @click="exportE()" size="small">导出</el-button>
			</div>
		</div>
		<el-table :data="list" ref="multipleTable" @selection-change="handleSelectionChange" stripe
			:header-cell-style="{ background: '#d8d8d8', 'text-align': 'center', color: '#2D2D2D' }"
			:cell-style="{'text-align': 'center'}" style="width: 100%" height='65vh'>
			<el-table-column type="selection" width="30"></el-table-column>
			<!-- <el-table-column label="ID" prop="id" sortable width="80px"></el-table-column> -->
			<el-table-column label="产品图片" width="120px">
				<template slot-scope="{row}">
					<el-image :src="row.img==null?'':row.img" :preview-src-list="typeImages" @click="bigImage(row)"
						style="height: 50px;"></el-image>
				</template>
			</el-table-column>
			<el-table-column prop="type" label="购买产品" width="150px"></el-table-column>
			<el-table-column label="用户ID" prop="userId" sortable width="100px"></el-table-column>
			<el-table-column label="填写的手机号" prop="userPhone" width="120px"></el-table-column>
			<el-table-column label="授权的手机号" prop="telphone" width="130px"></el-table-column>
			<el-table-column label="占位券码" prop="code" sortable width="150px"></el-table-column>
			<el-table-column label="状态" prop="status" sortable width="80px">
				<template slot-scope="scope">
					<el-tag v-if="scope.row.status == 0" type="danger">未充值</el-tag>
					<el-tag v-else type="success">已充值</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="添加时间" prop="addTime" sortable>
			</el-table-column>
			<el-table-column label="充值时间" prop="addTime" sortable>
				<template slot-scope="{row}">
					{{row.status==0?'/':row.rechargeTime}}
				</template>
			</el-table-column>
			<el-table-column label="备注" sortable width="200px">
				<template slot-scope="{row}">
					<div v-if="row.edit==false">{{row.remark?row.remark:'/'}}</div>
					<div v-else class='flex'>
						<el-input v-model="row.remark"></el-input>
						<el-button type="text" @click="changeRemark(row)">保存</el-button>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="编辑">
				<template slot-scope="scope">
					<el-button v-if="scope.row.edit==false" type="text" @click="scope.row.edit=true">修改备注</el-button>
					<el-button v-else type="text" @click="scope.row.edit=false">取消修改</el-button>
					<el-button v-if="scope.row.status == 0" type="text" @click="change(scope.row.id)">充值</el-button>
				</template>
			</el-table-column>
		</el-table>

		<div style="text-align: center;">
			<el-pagination background @current-change="handleCurrentChange" @size-change="handleSizeChange"
				:page-sizes="[100, 200, 500, 999999]" style="margin-top: 30px;"
				layout="total, sizes, prev, pager, next, jumper" :current-page="query.page" :total="query.total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import {
		url
	} from "../../../utils/index.js"
	export default {
		data() {
			return {
				list: [],
				distinctList: [],
				url: url(),
				query: {
					page: 1,
					size: 100,
					total: 0,
					time: [],
					startTime: '',
					endTime: '',
					status: '',
					type: 0,
					text: '',
				},
				queryUrl: '',
				ids: [], //多选项
				typeImages: [],
				keyss: [{
					label: "用户ID",
					value: 0,
				}, {
					label: "授权手机号",
					value: 1,
				}],
			}
		},
		mounted() {
			this.getList()
		},
		methods: {
			queryUrl01() {
				this.queryUrl = "?pageNum=" + this.query.page + "&pageSize=" + this.query.size
				if (this.query.time != null) {
					if (this.query.time.length > 0) {
						this.query.startTime = this.query.time[0]
						this.query.endTime = this.query.time[1]
						this.queryUrl += "&startTime=" + this.query.startTime + "&endTime=" + this.query.endTime
					}
				}
				if (this.query.phone != null) {
					this.queryUrl += "&telephone=" + this.query.phone
				}
				if (this.query.text != null) {
					this.queryUrl += "&bCreditPhoneUserId=" + this.query.text + "&type=" + this.query.type
				}

				if (this.query.status != null && this.query.status != '') {
					this.queryUrl += "&status=" + this.query.status
				}
			},
			getList() {
				this.queryUrl01()
				this.$http.get("activity/listPhoneCredit" + this.queryUrl).then(res => {
					this.list = res.body.data
					this.query.total = res.body.total
					this.list.forEach(d => {
						this.$set(d, "edit", false)
					})
				})
				this.$http.get("activity/listPhoneCreditDistinct").then(res => {
					this.distinctList = res.body.data
					if (this.distinctList.length > 0) {
						var tmp = []
						this.distinctList.forEach(i => {
							tmp.push(i.userPhone)
						})
						this.$notify({
							title: '同一券码存在多个手机号',
							dangerouslyUseHTMLString: true,
							type: 'warning',
							message: "手机号:" + tmp.join(","),
							duration: 0
						});
					}
				})
			},
			changeRemark(row) {
				row.edit = false
				this.$http.get("activity/change?id=" + row.id + "&remark=" + row.remark).then(res => {
					if (res.body.code == 200) {
						this.$message.success("保存成功")
						this.getList()
					} else {
						this.$message.error("保存失败")
					}
				})
			},
			change(id) {
				this.$confirm('确定已经充值？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get("activity/savePhoneCredit?id=" + id).then(res => {
						if (res.body.code == 200) {
							this.$message.success("保存成功")
							this.getList()
						} else {
							this.$message.error("保存失败")
						}
					})
				})
			},
			handleSelectionChange(val) {
				this.ids = []
				const idsArray = val
				if (idsArray != []) {
					if (idsArray.length > 0) {
						idsArray.forEach(item => {
							this.ids.push(item.id)
						})
					}
				}
			},
			changeMult() {
				this.$confirm('确定已经充值？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					if (this.ids != null) {
						if (this.ids.length == 0) {
							this.$message.error("没有选择充值项目")
						} else {
							this.$http.get("activity/savePhoneCreditMult?ids=" + this.ids).then(res => {
								if (res.body.code == 200) {
									this.$message.success("保存成功")
									this.getList()
								} else {
									this.$message.error("保存失败")
								}
							})
						}
					}
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					})
				});
			},
			toggleRowSelection(rows) {
				if (rows) {
					rows.forEach(row => {
						this.$refs.multipleTable.toggleRowSelection(row);
					});
				} else {
					this.$refs.multipleTable.clearSelection();
				}
			},
			exportE() {
				this.queryUrl01()
				window.location.assign(this.url + "activity/export" + this.queryUrl)
			},
			bigImage(row) {
				this.typeImages = []
				this.typeImages.push(row.img)
			},
			handleCurrentChange(val) {
				this.query.page = val;
				this.getList()
			},
			handleSizeChange(val) {
				this.query.size = val;
				this.getList()
			},
		}
	}
</script>

<style lang="less" scoped>
	.flex {
		display: flex;
	}

	::v-deep .el-table td {
		padding: 2px 0;
		min-width: 0;
		box-sizing: border-box;
		text-overflow: ellipsis;
		vertical-align: middle;
		position: relative;
		text-align: left;
	}
</style>